import setLang from '../lang';

const lang = {
    i: {
        locale: 'en-US',
        form_el: {
            test: 'please select',
        },
    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./goingsrc/locale/lang/en-US.js